<template>
    <PlaceholderPage :title="t.placeholder.monitoringTitle" :subtitle="t.placeholder.monitoringSubtitle" />
</template>

<script>
import PlaceholderPage from './PlaceholderPage.vue';
import { corporateI18n } from '@/i18n/mixins';

export default {
    name: 'CorporateMonitoring',
    mixins: [corporateI18n],
    components: { PlaceholderPage },
};
</script>
